class KlaviyoPopupTrigger extends HTMLElement {
    constructor() {
        super();
        this.triggerButton = this.querySelector('.klaviyo-trigger-selector');
        if (this.triggerButton) {
            this.triggerButton.addEventListener('click', this.openKlaviyoPopup.bind(this));
        } else {
            console.warn('No element with class "klaviyo-trigger-selector" found.');
        }
    }

    disconnectedCallback() {
        // Clean up event listener
        if (this.triggerButton) {
            this.triggerButton.removeEventListener('click', this.openKlaviyoPopup.bind(this));
        }
    }

    openKlaviyoPopup() {
        const formId = this.getAttribute('data-klaviyo-form');
        if (!formId) {
            console.warn('No Klaviyo form ID provided. Please add data-klaviyo-form attribute.');
            return;
        }

        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', formId]);
    }
}

customElements.define('klaviyo-popup-trigger', KlaviyoPopupTrigger);
